import React, {Component} from 'react';

class EmptyMessage extends Component {
    
    render() {
        let smaller = this.props.smaller ? 'smaller' : '';
        return (
            <li className={"single__message " + smaller}>
                <div className="message__sidebar message__sidebar--priority"></div>
                <div className="message">
                    <div className="message__inner message__inner--left">
                        <div className="subject">
                            Geen resultaten
                        </div>
                    </div>
                </div>
            </li>
        );
    }
    
}

export default EmptyMessage;



// WEBPACK FOOTER //
// ./src/components/Messages/EmptyMessage/index.js